import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

const AboutUs: React.FC = () => {
  return (
    <div className="font-sans text-gray-800">

      {/* Hero Banner */}
      <section id="banner" className="hero-banner">
        <img src="/media/hero-banner.jpg" alt="About Kilo Delta On Call" className="hero-banner-image" />
        <div className="hero-content">
            <img alt="Kilo Delta Logo" src="/media/logo-full.png" className="logo-hero-banner"/>
          <h1>ABOUT US</h1>
          <h2>OUR MISSION & VALUES</h2>
        </div>
      </section>

      {/* About Us Introduction */}
      <section className="about-intro-section">
        <div className="about-intro-content">
          <h2>About Us</h2>
          <p>Kilo Delta On Call is a registered Non-Profit Organization (NPO) dedicated to provide emergency response support in rural and underserved areas. Our mission is to ensure that every call for help receives a timely, professional, and compassionate response, by delivering rapid assistance during medical, fire, and search & rescue emergencies, especially where formal services are limited or experience extended response times. Our organization operates entirely on donations and community support, ensuring that vital emergency care and rescue services remain accessible and free of charge to those who need them most.</p>
        </div>
      </section>

      {/* Vision Section */}
      <section className="team-info-block">
        <div className="team-info-content">
          <div className="team-info-text">
            <h2 style={{ textAlign: 'center' }}>Vision</h2>
            <p>To build safer, resilient communities where every person regardless of location or circumstance has access to rapid, reliable, and compassionate emergency support.</p>
          </div>
          {/*<div className="team-info-image">*/}
          {/*  <img src="/media/team_3.jpeg" alt="Our Vision" />*/}
          {/*</div>*/}
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="mission-content">
          <h2>Mission</h2>
          <p>Kilo Delta On Call NPO is committed to delivering fast, professional, and cost-free emergency response support through a dedicated network of volunteers. We strive to strengthen and protect rural and underserved communities by providing medical care, fire support, search & rescue operations, and trauma assistance. Our mission is to ensure that every call for help is met with readiness, compassion, and unwavering commitment.</p>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="core-values-section">
        <div className="core-values-content">
          <h2>Core Values</h2>
          <p className="subtitle">Principles that guide our work</p>
          <ul className="core-values-list">
            <li><strong>Service:</strong> Putting community needs above all else.</li>
            <li><strong>Integrity:</strong> Acting with honesty, transparency, and accountability.</li>
            <li><strong>Compassion:</strong> Responding with empathy and care in every emergency.</li>
            <li><strong>Collaboration:</strong> Building strong partnerships for greater impact.</li>
            <li><strong>Excellence:</strong> Upholding the highest standards in emergency response.</li>
          </ul>
        </div>
      </section>

      {/* Why We Exist Section */}
      <section className="team-info-block">
        <div className="team-info-content">
          {/*<div className="team-info-image">*/}
          {/*  <img src="/media/1.jpeg" alt="Why We Exist" />*/}
          {/*</div>*/}
          <div className="team-info-text">
            <h2 style={{ textAlign: 'center' }}>Why We Exist</h2>
            <p>MMany rural communities face long delays in receiving emergency assistance, putting lives and property at risk. With increasing demand on state and private emergency services, these areas are often underserved. Kilo Delta On Call fills this gap by being a volunteer first response lifeline, giving vulnerable communities a fighting chance during crises.</p>
          </div>
        </div>
      </section>

      {/* Sustainability Model Section */}
      <section className="sustainability-section">
        <div className="sustainability-content">
          <h2>Sustainability Model</h2>
          <p>Our operations are funded exclusively by donations from businesses, organizations, and
          the public. Every contribution whether financial, equipment, or volunteer time directly
          supports our ability to save lives. We are committed to full transparency and
          accountability, ensuring that resources are used effectively and responsibly to benefit the
          communities we serve.</p>
        </div>
      </section>

      {/* Collaboration & Partnerships Section */}
      <section className="team-info-block">
        <div className="team-info-content">
          <div className="team-info-text">
            <h2 style={{ textAlign: 'center' }}> Collaboration & Partnerships</h2>
            <p>Kilo Delta On Call recognizes that emergency response requires teamwork. We actively
            collaborate with municipalities, healthcare providers, fire services, and fellow non-profit
            organizations to maximize our reach and impact.</p>
          </div>

        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact US</h4>
            <ul>
              <li><a href="mailto:info@kilodeltaoncall.org">info@kilodeltaoncall.org</a></li>
              <li><a href="tel:0832779727">John: 083 277 9727</a></li>
              <li><a href="tel:0872655289">Support: 0872 655 289</a></li>
              <li><a href="#facebook">Facebook</a></li>
              <li><a href="#twitter">X.com (Twitter)</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Get Involved</h4>
            <ul>
              <li><a href="mailto:info@kilodeltaoncall.org">Donate Now</a></li>
              <li><a href="mailto:info@kilodeltaoncall.org">Become a Volunteer</a></li>
              <li><a href="mailto:info@kilodeltaoncall.org">Career Opportunities</a></li>
              <li><a href="mailto:info@kilodeltaoncall.org">Partner With Us</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Kilo Delta On Call (NPO). Registration Number 2025/750743/08. A registered non-profit organization dedicated to emergency support response. All rights reserved.</p>
          <p style={{ marginTop: '10px' }}>
            <a href="#terms">Terms and Conditions</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;
